import { container } from '../../../DataDomain';
import { ISlpRepository } from '../../repositories/interfaces/iSlpRepository';
import { DI } from '@intigral/constant/config/DIContainer';
import { IItemsToPurchase, IAddonPurchaseResponse, CSRFTokenRequest } from '../../../entity';

export interface IPurchaseAddonUseCase {
    execute(
        username: string,
        itemsToPurchase: IItemsToPurchase[],
        pin: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IAddonPurchaseResponse>;
}

export class PurchaseAddonUseCase implements IPurchaseAddonUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get slpRepo(): ISlpRepository {
        return container.resolve<ISlpRepository>(DI.REPOSITORIES.ISlpRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        itemsToPurchase: IItemsToPurchase[],
        pin: string,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IAddonPurchaseResponse> {
        return await this.slpRepo.purchaseAddon(
            username,
            itemsToPurchase,
            pin,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
    }
}
